document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.pau-cta').forEach(function(el) {
    var variantId = el.dataset.variant;
    var url = el.dataset.url;
    var img = el.dataset.img;
    var name = el.dataset.name;
    var price = el.dataset.price;
    var badge = el.dataset.badge || 'Top Pick';
    var desc = el.dataset.desc || '';
    var btnId = 'pau-atc-' + variantId;

    el.innerHTML = `
      <style>
        .pau-cta-card {
          font-family: 'DM Sans', sans-serif;
          background: #ffffff;
          border-radius: 22px;
          overflow: hidden;
          display: grid;
          grid-template-columns: 180px 1fr;
          box-shadow: 0 8px 8px rgba(10,107,138,.08);
          margin: 40px 0;
          border: 1.5px solid rgba(10,107,138,.10);
          position: relative;
          transition: transform .25s, box-shadow .25s;
        }
        .pau-cta-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 12px rgba(10,107,138,.12);
        }
        .pau-cta-card .badge {
          position: absolute;
          top: 16px; left: 16px;
          background: #FF00FC;
          color: #fff;
          font-size: .72rem;
          font-weight: 700;
          letter-spacing: .06em;
          text-transform: uppercase;
          padding: 4px 10px;
          border-radius: 100px;
          z-index: 2;
        }
        .pau-cta-card .card-img {
          background: linear-gradient(135deg, #c9eaf5 0%, #a0d8ef 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 170px;
          overflow: hidden;
        }
        .pau-cta-card .card-img img {
          width: 100%; height: 100%; object-fit: cover;
        }
        .pau-cta-card .card-body {
          padding: 22px 24px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 8px;
        }
        .pau-cta-card .eyebrow {
          font-size: .8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: .1em;
          color: #38b2d4;
        }
        .pau-cta-card .board-name {
          font-family: Georgia, serif;
          font-size: 1.25rem;
          color: #1a2733;
          line-height: 1.25;
          font-weight: 700;
        }
        .pau-cta-card .board-desc {
          font-size: .88rem;
          color: #6b8898;
          line-height: 1.5;
        }
        .pau-cta-card .card-footer {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 6px;
          flex-wrap: wrap;
        }
        .pau-cta-card .price {
          font-size: 1.3rem;
          font-weight: 700;
          color: #0a6b8a;
        }
        .pau-cta-card .btn {
          display: inline-flex;
          align-items: center;
          font-size: .88rem;
          font-weight: 600;
          padding: 10px 40px;
          border-radius: 100px;
          cursor: pointer;
          border: none;
          text-decoration: none;
          transition: background .2s, transform .15s;
          white-space: nowrap;
          font-family: 'DM Sans', sans-serif;
        }
        .pau-cta-card .btn-primary {
          background: #0a6b8a;
          color: #fff;
          box-shadow: 0 4px 4px rgba(10,107,138,.1);
        }
        .pau-cta-card .btn-primary:hover { background: #074f68; }
        .pau-cta-card .btn-ghost {
          background: transparent;
          color: #0a6b8a;
          border: 1.5px solid #0a6b8a;
        }
        .pau-cta-card .btn-ghost:hover { background: #f0fafe; }
        @media (max-width: 600px) {
          .pau-cta-card { grid-template-columns: 1fr; }
          .pau-cta-card .card-img { min-height: 160px; }
        }
      </style>

      <div class="pau-cta-card">
        <span class="badge">${badge}</span>
        <div class="card-img">
          <img src="${img}" alt="${name}" loading="lazy" />
        </div>
        <div class="card-body">
          <span class="eyebrow">Featured Board</span>
          <div class="board-name">${name}</div>
          <div class="board-desc">${desc}</div>
          <div class="card-footer">
            <span class="price">${price}</span>
            <button type="button" class="btn btn-primary" id="${btnId}">Add to Cart</button>
            <a href="${url}" class="btn btn-ghost">View Board</a>
          </div>
        </div>
      </div>
    `;

    // Attach ATC logic after HTML is injected
    var btn = document.getElementById(btnId);
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      btn.textContent = 'Adding...';
      btn.style.opacity = '0.7';
      btn.disabled = true;

      var failsafe = setTimeout(function() {
        btn.textContent = 'Add to Cart';
        btn.style.background = '#0a6b8a';
        btn.style.opacity = '1';
        btn.disabled = false;
      }, 5000);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: parseInt(variantId), quantity: 1})
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        clearTimeout(failsafe);
        btn.textContent = '✓ Added to Cart';
        btn.style.opacity = '1';
        btn.style.background = '#FF00FC';

fetch('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    document.querySelectorAll('[data-cart-count], .cart-count, #cart-count').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    var cartEl = document.querySelector('cart-element.cart-drawer');
    if (cartEl && typeof cartEl.getCart === 'function') {
      cartEl.getCart().then(function() {
        if (typeof cartEl.openCartDrawer === 'function') cartEl.openCartDrawer();
      });
    } else if (cartEl && typeof cartEl.openCartDrawer === 'function') {
      cartEl.openCartDrawer();
    }
  });

        setTimeout(function() {
          btn.textContent = 'Add to Cart';
          btn.style.background = '#0a6b8a';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function(err) {
        clearTimeout(failsafe);
        console.error('ATC error:', err);
        btn.textContent = '✕ Something went wrong';
        btn.style.background = '#c0392b';
        btn.style.opacity = '1';
        btn.disabled = false;
        setTimeout(function() {
          btn.textContent = 'Add to Cart';
          btn.style.background = '#0a6b8a';
        }, 2000);
      });
    });
  });
});